import { useEffect, useState } from "react";
import styles from "../assets/css/Prices.module.css";
import axios from "axios";
import { BASE_URL } from "../constants/constants";

const PricesComponent = ({ headers }) => {
  const [prices, setPrices] = useState([]);
  const [isSaving, setIsSaving] = useState(null);

  const fieldNames = {
    defaultCost: "Стоимость по умолчанию",
    perMinute: "В минуту",
    perKilometer: "За километр",
    forAwaiting: "За ожидание",
    needHelp: "Нужна помощь",
    childSeat: "Детское кресло",
    orderToChild: "Заказ ребенку",
  };

  const fetchPrices = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/v0/trip/prices`, {
        headers,
      });
      setPrices(response.data.result);
    } catch (error) {
      console.error("Ошибка при получении данных", error);
    }
  };

  const updatePrices = async (priceObj) => {
    setIsSaving(priceObj.id);
    try {
      await axios.patch(`${BASE_URL}/v0/trip/prices/${priceObj.id}`, priceObj, {
        headers: {
          "Content-Type": "application/json",
          ...headers,
        },
      });
      alert(`Цены для города ${priceObj.city} успешно обновлены!`);
    } catch (error) {
      console.error("Ошибка при обновлении данных", error);
      alert(
        `Не удалось обновить цены для города ${priceObj.city}. Попробуйте снова.`
      );
    } finally {
      setIsSaving(null);
    }
  };

  useEffect(() => {
    fetchPrices();
  }, []);

  const handleChange = (cityId, key, value) => {
    setPrices((prev) =>
      prev.map((price) =>
        price.id === cityId ? { ...price, [key]: value } : price
      )
    );
  };

  return (
    <div>
      {prices.map((cityPrice) => (
        <div key={cityPrice.id} className={styles.cityBlock}>
          <h3 className={styles.cityTitle}>{cityPrice.city}</h3>
          {Object.entries(fieldNames).map(([key, label]) => (
            <div className={styles.block1} key={key}>
              <div className={styles.box}>
                <div className={styles.box1}>
                  <div className={styles.title}>{label}</div>
                </div>
                <div className={styles.box2}>
                  <input
                    className={styles.input}
                    type="number"
                    value={cityPrice[key]}
                    onChange={(e) =>
                      handleChange(cityPrice.id, key, Number(e.target.value))
                    }
                  />
                  <span className={styles.symbol}>〒</span>
                </div>
              </div>
            </div>
          ))}
          <div className={styles.button}>
            <button
              className={styles.savebtn}
              onClick={() => updatePrices(cityPrice)}
              disabled={isSaving === cityPrice.id}
            >
              {isSaving === cityPrice.id ? "Сохранение..." : "Сохранить"}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PricesComponent;
